export const QUESTIONNAIRE_TRANSLATED = 'QUESTIONNAIRE_TRANSLATED';
export const REPORT_TEXTS_TRANSLATED = 'REPORT_TEXTS_TRANSLATED';
export const JPS_TRANSLATED = 'JPS_TRANSLATED';
export const VALIDATED = 'VALIDATED';

export const SECTION = 'SECTION';
export const SURVEY = 'SURVEY';
export const BEHAVIOR_SECTION = 'behavior';
export const COGNITIVE_SECTION = 'cognitive';
export const INTERESTS_SECTION = 'interests';
export const STANDARD_ITEM_TYPE = 'STANDARD';
export const JOB_PROFILE_SURVEY_ITEM_TYPE = 'JOB_PROFILE_SURVEY';
export const INITIAL_KSS_TEXT_VALUES = {
  itemCode: '',
  kssTextType: '',
  level: '',
  sequence: '',
};
